module.exports = __webpack_public_path__ + "img/B_ezplan3.04cd016b.png";